module.exports = __webpack_public_path__ + "img/Embers-Adrift-2022-006.2d4a0fd2.jpg";